/* eslint-disable no-nested-ternary */
import styled from 'styled-components'
import { colors } from '../../theme'

export const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
  .editPermissoes {
    margin-top: 15px;
  }
`

export const Search = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  .editPermissoes {
    margin-top: 15px;
  }
`

export const InputStyle = styled.input<{
  border: string
  sizeY: string
  sizeX: string
}>`
  outline: none;
  border: 1px solid ${colors.grey300};
  border-radius: 10px;
  margin-top: 20px; //retirar
  margin-bottom: 15px;
  font-size: 13px;
  padding: 15px;
  padding-right: 55px;

  border: 1.5px solid ${({ border }) => border};
  border-radius: 12px;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  font-size: 12px;
  margin-top: 15px;
`

export const Span = styled.button`
  position: absolute;
  top: 40px;
  left: 260px;
  border: none;
  background-color: transparent;
  cursor: pointer;
`

export const DivInput = styled.div`
  padding: 15px 30px;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  border-radius: 24px;
  margin-bottom: 20px;
  position: relative;
  background-color: ${colors.surface};
`

export const ButtonIcon = styled.button<{
  padding?: string
}>`
  border: none;
  background-color: ${colors.overlay1};
  padding-left: ${({ padding }) => padding};
  cursor: pointer;
`
export const BaseIntegracao = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px ${colors.grey300};
  background-color: ${colors.surface};
  border-radius: 100px;
  width: 35px;
  height: 35px;
  padding: 0;
`
export const BaseEdit = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px ${colors.grey300};
  background-color: ${colors.surface};
  border-radius: 100px;
  width: 35px;
  height: 35px;
  padding: 0;
  cursor: pointer;
`

export const ButtonNewUser = styled.button`
  width: 160px;
  height: 40px;
  background-color: ${colors.accentBg};
  text-decoration: none;
  color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  font-size: 12px;
  cursor: pointer;
  border: none;

  h3 {
    font-weight: 500;
  }
`
export const Td = styled.div<{ classification: boolean }>`
  color: ${({ classification }) =>
    classification ? `${colors.secondaryText}` : `${colors.errorText}`};
  padding: 5px 0px 10px 0px;
  border-radius: 9px;
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
`
